import ProfileDropDown from '../../components/common/ProfileDropDown';
import { NavLink, useLocation } from 'react-router-dom';
import SearchInput from '../../components/common/SearchInput';
import { useCommonStore } from '../../stores/commonStore';
import { useHistory } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { ROUTES_WITHOUT_HEADER, setLocalActiveRole } from '../../utils/authUtils';
import { USER, LOGO } from '../../utils/constants/images';
import { HAMB_MENU_ICON } from '../../utils/constants/icons';
import { Roles } from '../../utils/enums';
import DownloadProgressDropdown from '../../components/DownloadProgressDropdown';

const Header = () => {
    const setSidebarOpen = useCommonStore((state) => state.setSideBarOpen);
    const sideBarOpen: boolean = useCommonStore((state) => state.sideBarOpen);
    const user = useAuthStore((state) => state.user);
    const activeRole = useAuthStore((state) => state.activeRole);
    const setActiveRole = useAuthStore((state) => state.setActiveRole);
    const showDownloadDropdown: boolean = useCommonStore((state) => state.showDownloadDropdown);
    const setShowDownloadDropdown = useCommonStore((state) => state.setShowDownloadDropdown);
    const downloadProgress = useCommonStore((state) => state.downloadProgress);

    const allowedRoles = user?.roles?.length ? user.roles.map((role) => role.name) : [];

    const { pathname } = useLocation();
    const history = useHistory();
    const handleMenuIconClick = () => {
        setSidebarOpen(!sideBarOpen);
    };

    if (ROUTES_WITHOUT_HEADER.includes(pathname)) return <></>;

    const handleChangeRole = (role) => {
        history.push('/');
        setActiveRole(Roles[role]);
        setLocalActiveRole(Roles[role]);
    };
    return (
        <header className="bg-white dark:bg-gray-800 shadow-sm sticky top-0 z-30">
            <button className="absolute left-0 top-1 p-4" onClick={handleMenuIconClick}>
                <img src={HAMB_MENU_ICON} alt="" />
            </button>
            <div className="mx-auto px-16">
                <div className="flex items-center justify-between h-16">
                    <div className=" flex items-center">
                        <NavLink className="flex-shrink-0" to="/">
                            <img src={LOGO} width="104" height="31" alt="" />
                        </NavLink>
                        {/* <div className="hidden md:block">
                            <HeaderNav />
                        </div> */}
                    </div>

                    <div className="block">
                        <div className="ml-4 flex items-center md:ml-6">
                            {/* <SearchInput placeholder="Search FSN, Request & etc" /> */}
                            <div className="relative ml-6 ">
                                <div className=" cursor-pointer" onClick={() => setShowDownloadDropdown(!showDownloadDropdown)}>
                                    <svg width="24" height="29" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M27.6502 15H25.0002V6.66667C25.0002 5.75 24.2502 5 23.3335 5H16.6668C15.7502 5 15.0002 5.75 15.0002 6.66667V15H12.3502C10.8668 15 10.1168 16.8 11.1668 17.85L18.8168 25.5C19.4668 26.15 20.5168 26.15 21.1668 25.5L28.8168 17.85C29.8668 16.8 29.1335 15 27.6502 15ZM8.3335 31.6667C8.3335 32.5833 9.0835 33.3333 10.0002 33.3333H30.0002C30.9168 33.3333 31.6668 32.5833 31.6668 31.6667C31.6668 30.75 30.9168 30 30.0002 30H10.0002C9.0835 30 8.3335 30.75 8.3335 31.6667Z"
                                            fill="#717478"
                                        />
                                    </svg>
                                </div>
                                {showDownloadDropdown && (
                                    <div className=" bg-white mt-7 w-96 py-5 px-3 right-0 absolute rounded-md shadow-lg z-50">
                                        <DownloadProgressDropdown downloadProgress={downloadProgress} />
                                    </div>
                                )}
                            </div>

                            <div className="ml-3 relative">
                                <ProfileDropDown activeRole={activeRole} iconUrl={USER} allowedRoles={allowedRoles} handleChangeRole={handleChangeRole} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
